// Central catalog of data-testid values
export const NAV = {
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkWhy: "nav-link-why",
  linkExpert: "nav-link-expert",
  linkPractice: "nav-link-practice",
  linkContact: "nav-link-contact",
  downloadCv: "nav-download-cv",
};

export const HERO = {
  container: "hero-section",
  downloadCv: "hero-download-cv-btn",
  execSummary: "hero-exec-summary-btn",
  contact: "hero-contact-btn",
  linkedin: "hero-linkedin-link",
};

export const CONTACT = {
  form: "board-inquiry-form",
  name: "inquiry-name-input",
  email: "inquiry-email-input",
  org: "inquiry-org-input",
  role: "inquiry-role-input",
  message: "inquiry-message-input",
  submit: "inquiry-submit-btn",
  cvDownload: "contact-download-cv-btn",
  execSummary: "contact-exec-summary-btn",
};

export const FOOTER = {
  linkedin: "footer-linkedin",
  email: "footer-email",
};
